import React from 'react';
// styles
import { Wrapper } from './Footer.styles';

const Footer = () => {
  return (
    <Wrapper>
      <footer className='footer text-center p-1'>
        <a
          href='https://tarek-saimouah.github.io'
          target='_blank'
          className='pb-3 pt-2 copyright'
          rel='noreferrer'
        >
          {`© tarek-saimouah.github.io ${new Date().getFullYear()}`}
        </a>
      </footer>
    </Wrapper>
  );
};

export default Footer;
